import { Button, Dialog, DialogActions } from '@wodi/ui';
import { useState, type ReactNode } from 'react';

import { useRetryQueue } from './offline-status.tsx';

// Signing out deletes everything saved on this device (drafts and the retry queue), for
// privacy on shared workstations (ADR 0018). When actions are still waiting to be sent,
// the person is told first and can stay signed in until they are sent.

export function useGuardedSignOut(signOut: () => void): {
  requestSignOut: () => void;
  dialog: ReactNode;
} {
  const items = useRetryQueue();
  const [open, setOpen] = useState(false);
  const count = items.length;
  const requestSignOut = () => {
    if (count === 0) signOut();
    else setOpen(true);
  };
  const dialog = (
    <Dialog title="Actions not sent yet" isOpen={open} onOpenChange={setOpen}>
      <p>
        {count === 1
          ? '1 action saved on this device has not been sent to Wodi. Signing out deletes it from this device.'
          : `${String(count)} actions saved on this device have not been sent to Wodi. Signing out deletes them from this device.`}
      </p>
      <DialogActions>
        <Button
          variant="quiet"
          onPress={() => {
            setOpen(false);
            signOut();
          }}
        >
          Sign out and delete them
        </Button>
        <Button
          variant="primary"
          onPress={() => {
            setOpen(false);
          }}
        >
          Stay signed in
        </Button>
      </DialogActions>
    </Dialog>
  );
  return { requestSignOut, dialog };
}
